import Vue, { VueConstructor } from 'vue';
/** 缓存component实例 */
const cacheMap: {
  [key: symbol]: Vue;
} = {};

/**
 * 创建一个新的vue实例，将组建挂载到页面dom上，适用于全局的通用组件，dialog、loading等
 * @param component 组件实例
 * @param name 组件名称，有名称的组件可以缓存下来
 * @param options 组件参数
 * @returns
 */
export function loadComponent(component: VueConstructor, name: symbol, options?: any) {
  // 若存在缓存，直接返回对象
  if (name && cacheMap[name]) {
    return cacheMap[name];
  }
  // 创建vue对象
  const vueObj = new Vue({
    render(h) {
      return h(component, { props: (this as any).data });
    },
    data() {
      return {
        data: options,
      };
    },
  });
  // 挂载到body上
  vueObj.$mount(document.createElement('div'));
  document.body.appendChild(vueObj.$el);
  const [child] = vueObj.$children;
  // 若存在名字，则缓存
  if (name) {
    cacheMap[name] = child;
  }
  return child;
}
